import { Atom, Book, Brain, Globe, Heart, Layers, Megaphone, Star, Trophy, Zap } from 'lucide-react'

export const heroFloatingIcons = [
  {
    icon: Book,
    image: '/images/landing/home/1.png',
    color: 'text-blue-400',
    glowColor: 'bg-blue-500/20',
    top: '17%',
    left: '11%',
    range: [0.0, 0.5],
    yRange: [0, 600],
    xRange: [0, 300],
    delay: 0,
    animateY: [0, -20, 0],
    animateRotate: [0, 10, 0],
  },
  {
    icon: Globe,
    image: '/images/landing/home/2.png',
    color: 'text-primary',
    glowColor: 'bg-primary/20',
    top: '38%',
    left: '24%',
    range: [0.1, 0.6],
    yRange: [0, 750],
    xRange: [0, 200],
    delay: 0.2,
    animateY: [0, 15, 0],
    animateX: [-10, 0, -10],
  },
  {
    icon: Trophy,
    image: '/images/landing/home/3.png',
    color: 'text-cyan-400',
    glowColor: 'bg-primary/20',
    top: '48%',
    left: '7%',
    range: [0.05, 0.55],
    yRange: [0, 500],
    xRange: [0, 350],
    delay: 0.5,
    animateY: [0, 15, 0],
    animateX: [0, 10, 0],
  },
  {
    icon: Zap,
    image: '/images/landing/home/4.png',
    color: 'text-yellow-400',
    glowColor: 'bg-yellow-500/20',
    top: '65%',
    left: '15%',
    range: [0.15, 0.65],
    yRange: [0, 850],
    xRange: [0, 250],
    delay: 0.8,
    animateScale: [1, 1.1, 1],
    animateRotate: [0, -15, 0],
  },
  {
    icon: Layers,
    image: '/images/landing/home/5.png',
    color: 'text-purple-400',
    glowColor: 'bg-purple-500/20',
    top: 'auto',
    bottom: '12%',
    left: '4%',
    range: [0.2, 0.7],
    yRange: [0, 700],
    xRange: [0, 380],
    delay: 1,
    animateY: [0, 25, 0],
    animateScale: [1, 1.1, 1],
  },
  {
    icon: Megaphone,
    image: '/images/landing/home/6.png',
    color: 'text-pink-400',
    glowColor: 'bg-pink-500/20',
    top: '12%',
    right: '8%',
    range: [0.02, 0.52],
    yRange: [0, 650],
    xRange: [0, -320],
    delay: 0.5,
    animateY: [0, -25, 0],
    animateRotate: [0, -10, 0],
  },
  {
    icon: Star,
    image: '/images/landing/home/7.png',
    color: 'text-blue-300',
    glowColor: 'bg-blue-400/20',
    top: '35%',
    right: '27%',
    range: [0.12, 0.62],
    yRange: [0, 550],
    xRange: [0, -180],
    delay: 0.7,
    animateY: [0, -15, 0],
    animateX: [10, 0, 10],
  },
  {
    icon: Brain,
    image: '/images/landing/home/8.png',
    color: 'text-yellow-500',
    glowColor: 'bg-yellow-500/20',
    top: '40%',
    right: '7%',
    range: [0.07, 0.57],
    yRange: [0, 800],
    xRange: [0, -340],
    delay: 1.2,
    animateY: [0, 15, 0],
    animateScale: [1, 1.2, 1],
  },
  {
    icon: Heart,
    image: '/images/landing/home/9.png',
    color: 'text-emerald-400',
    glowColor: 'bg-emerald-500/20',
    top: '62%',
    right: '16%',
    range: [0.17, 0.67],
    yRange: [0, 620],
    xRange: [0, -260],
    delay: 1.4,
    animateY: [15, 0, 15],
    animateScale: [1, 1.1, 1],
  },
  {
    icon: Atom,
    image: '/images/landing/home/10.png',
    color: 'text-blue-400',
    glowColor: 'bg-blue-500/20',
    top: 'auto',
    bottom: '16%',
    right: '4%',
    range: [0.22, 0.72],
    yRange: [0, 720],
    xRange: [0, -360],
    delay: 1.5,
    animateY: [0, 20, 0],
    animateRotate: [0, 15, 0],
  },
]

